export const CALENDAR = 'calendar';
export const EPISODES = 'episodes';
export const INTERACTIVE_IMPORT = 'interactiveImport.episodes';
export const WANTED_CUTOFF_UNMET = 'wanted.cutoffUnmet';
export const WANTED_MISSING = 'wanted.missing';

export default {
  CALENDAR,
  EPISODES,
  INTERACTIVE_IMPORT,
  WANTED_CUTOFF_UNMET,
  WANTED_MISSING,
} as const;
